import { apiRequest } from "@/lib/api";

const FIRST_LOGIN_PROMO_PATH = "/api/v1/account/promo-code";

export type FirstLoginPromoStatus = {
  prompt_required: boolean;
  redeemed: boolean;
  wallet_free: boolean;
  success_message?: string;
};

export async function readFirstLoginPromoStatus(): Promise<FirstLoginPromoStatus> {
  return apiRequest<FirstLoginPromoStatus>(FIRST_LOGIN_PROMO_PATH, {
    method: "GET",
    cache: "no-store",
    timeoutMs: 8_000,
  });
}

export async function skipFirstLoginPromo(): Promise<FirstLoginPromoStatus> {
  return apiRequest<FirstLoginPromoStatus>(FIRST_LOGIN_PROMO_PATH, {
    method: "POST",
    body: { action: "skip" },
    cache: "no-store",
    timeoutMs: 8_000,
  });
}

export async function redeemFirstLoginPromo(
  code: string,
): Promise<FirstLoginPromoStatus> {
  return apiRequest<FirstLoginPromoStatus>(FIRST_LOGIN_PROMO_PATH, {
    method: "POST",
    body: { action: "redeem", code },
    cache: "no-store",
    timeoutMs: 8_000,
  });
}
